/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionRouteNavigate} from '../../../store/actions/actions-route';
import {ActionCreateSupport} from '../../../store/actions/actions-request';
import ContactForm from '../../ContactForm/ContactForm';

class ModalContactForm extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center',
      closeButton: true,
      keyboard: true,
    });
  }

  onCancelClick = () => {
    this.props.ActionModalHide();
  };

  onSubmitForm = (data, isFormData, callback) => {
    const newCallback = () => {
      callback();
      this.onCancelClick();
    };
    this.props.ActionCreateSupport(data, isFormData, newCallback);
  };

  render() {
    const selectOptions = [
      {value: 5, label: 'Сайты клоны'},
      {value: 6, label: 'Фальшивая рассылка'},
      {value: 7, label: 'Недобросовестные работодатели'},
      {value: 4, label: 'Своя тема'},
    ];

    const contentText = '<p class="text-sm">Уважаемые пользователи!</p>'
      + '<p class="text-sm">Если Вы обнаружили любые виды злоупотреблений связанные с работой платформы для контактного подбора персонала My new job ®, просьба незамедлительно сообщить об этом администрации сайта My new job ® по форме ниже.</p>';

    return (
      <ModalBaseLayout {...this.settings}>
        <ContactForm
          onSubmit={this.onSubmitForm}
          title="Сообщение администрации сайта My new job®"
          options={selectOptions}
          inline
          text={contentText}
          iconType="icon-rogue"
        />
      </ModalBaseLayout>
    );
  }
}

ModalContactForm.propTypes = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionRouteNavigate,
    ActionCreateSupport,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ModalContactForm);
